import React from 'react'
import { sendCommentToApi } from '../actions/comments'
import ReactStars from 'react-stars'
import { connect } from 'react-redux'
import './comment-form.css'
import { nonEmpty } from '../validators.js'

export class CommentForm extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			rating: 0,
            isEmpty: ''
		}

		this.onSubmit = this.onSubmit.bind(this)
		this.changeRating = this.changeRating.bind(this)
	}

	changeRating(newRating) {
      this.setState({
        rating: newRating
      });
    }


    onSubmit() {
        const commentInfo = {
            rating: this.state.rating,
            value: this.text.value,
            uid: this.props.uid,
            item: this.props.item,
            isEdit: this.props.isEdit
        }
        
        this.text.value = ''
        this.setState({ rating: 0 })
        if(nonEmpty(commentInfo.value) === undefined) {

            this.setState({ isEmpty: '' })
            return this.props.dispatch(sendCommentToApi(commentInfo))
        }
        else this.setState({ isEmpty: nonEmpty(commentInfo.value) })
	}

    render() {
        let isEmptyMessage
        if(this.state.isEmpty.length) {
            isEmptyMessage = (
                <div className='empty-message'>
                    {this.state.isEmpty}
                </div>
            )
        }

    	return (
    		<div className='col-3 comment-form'>
                { isEmptyMessage }
                <label htmlFor='comment'>Leave a comment</label>
                <div className='comment-box'>
                    <textarea name='comment' ref={input => this.text = input}/>
                    <button className='comment-submit' onClick={this.onSubmit}>
                        Submit
                    </button>
                    <ReactStars 
                        className='react-stars'
                        name='rating' 
                        count={5}
                        color1='#7103a0'
                        color2='#4fff7b'
                        isSelectable={true}
                        onChange={this.changeRating}
                        size={24}
                        half={false}
                        value={this.state.rating}
                        />
                </div>
    		</div>
    	)
    }
}

const mapStateToProps = state => ({
    uid: state.auth.uid
})
export default connect(mapStateToProps)(CommentForm)


// WEBPACK FOOTER //
// ./src/components/comment-form.js